'use client';

import Icon from '@/components/ui/AppIcon';

interface MetricsCardProps {
  title: string;
  value: number;
  icon: string;
  color: 'primary' | 'secondary' | 'accent' | 'success';
}

export default function MetricsCard({ title, value, icon, color }: MetricsCardProps) {
  const colorClasses = {
    primary: 'text-primary bg-primary/10',
    secondary: 'text-secondary bg-secondary/10',
    accent: 'text-accent bg-accent/10',
    success: 'text-success bg-success/10',
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-card border border-border hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <div className={`p-2 rounded-lg ${colorClasses[color]}`}>
          <Icon name={icon} size={20} />
        </div>
      </div>
      <p className="text-3xl font-bold text-foreground">{value.toLocaleString()}</p>
    </div>
  );
}